const Notify = require('notifyjs');
const locales = require('../translations');

exports.initNotify = () => {
    if (Notify.needsPermission && Notify.isSupported()) {
        Notify.requestPermission(
            () => initNotification.show()
        );
    }
};

exports.makeNotify = (order, language) => {
    const browserNotify = locales.default[language].browserNotify;
    let iconUrl, body, title;

    if (order.isSos) {
        title = browserNotify.sos;
        iconUrl = '/img/icons/pins/driver-busy@2x.png';
    } else if (order.isLate) {
        title = browserNotify.late;
        iconUrl = '/img/icons/pins/driver-enroute@2x.png';
    } else if (order.cancelSource) {
        title = browserNotify.cancel;
        iconUrl = '/img/icons/pins/driver-busy@2x.png';
    } else if (order.status == 'new') {
        title = browserNotify.new;
        iconUrl = '/img/icons/pins/driver-online@2x.png';
    }
    const user = (order.client && order.client.user) || {};
    const firstName = user.firstName ? user.firstName : '';
    const lastName = user.lastName ? user.lastName : '';
    const phone = user.phoneNumber ? user.phoneNumber : '';
    const brand = (order.brand && order.brand.title) ? order.brand.title : '';
    const callSign = (order.driver && order.driver.callSign) ? order.driver.callSign : '';
    const address = order.addresses && order.addresses.map(it => it.street + ' ' + it.houseNumber).join(', ');

    if (order.status == 'new') {
        body = `${brand} ${phone}
            ${browserNotify.client}${firstName} ${lastName}
        `;
    } else {
        body =` ${ brand} \n ${browserNotify.client}${firstName} ${lastName}  ${phone} \n ${browserNotify.driver}: ${callSign} \n ${browserNotify.address}${address}`;
    }
    if (order.cancelSource) {
        body = browserNotify[order.cancelSource];
    }

    const options = {
        body: body || '',
        icon: iconUrl || '',
        closeOnClick: true,
        notifyClick: () => window.focus()
    };
    title = title ? title.toUpperCase() : 'Alert';

    return new Notify(title, options);
};

const initNotification = new Notify(
    'init', {
        body: 'apply notifications',
        closeOnClick: true,
        notifyClick: () => window.focus()
    });
